import React, { useEffect, useState } from 'react';

import { FixedWrapperPortal } from '@commons/fixed-wrapper/FixedWrapper';

import * as styles from './reading-progress.module.scss';

const getViewportHeight = () => {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
};

export function ReadingProgress({ targetEl }) {
  const [value, setValue] = useState(0);
  const [max, setMax] = useState(1);

  useEffect(() => {
    const target = document.querySelector(targetEl);
    const viewportHeight = getViewportHeight();

    const onResize = () => {
      const { height } = target.getBoundingClientRect();
      setMax(height - viewportHeight + target.offsetTop);
    };
    const onScroll = () => {
      setValue(window.pageYOffset || document.documentElement.scrollTop);
    };
    onResize();
    onScroll();
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('scroll', onScroll);
    };
  }, [targetEl]);

  return (
    <FixedWrapperPortal>
      <progress value={value} max={max} className={styles.readingProgress} />
    </FixedWrapperPortal>
  );
}
